import { useTheme } from '@mui/material';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

interface PluginGroupHeaderProps {
  title: string;
  description?: string;
  badge?: string;
}

const PluginGroupHeader = (props: PluginGroupHeaderProps) => {
  const theme = useTheme();

  return (
    <div className="mb-3 flex flex-col">
      <div className="flex items-center gap-2">
        <Typography variant="h6" sx={{ color: theme.palette.secondary.main, fontWeight: 700 }}>
          {props.title}
        </Typography>
        {props.badge && (
          <Chip
            label={props.badge}
            size="small"
            sx={{
              backgroundColor: theme.palette.primary.lighter,
              color: theme.palette.primary.darker,
              fontWeight: 600,
              fontSize: '0.7rem',
            }}
          />
        )}
      </div>
      {props.description && (
        <Typography variant="caption" color="text.secondary">
          {props.description}
        </Typography>
      )}
    </div>
  );
};

export default PluginGroupHeader;
